import { render, staticRenderFns } from "./MdmSetup.vue?vue&type=template&id=1b6f0312&"
import script from "./MdmSetup.vue?vue&type=script&lang=js&"
export * from "./MdmSetup.vue?vue&type=script&lang=js&"
import style0 from "./MdmSetup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports